import './PageLoader.scss';

import cn from 'classnames';
import lottie from 'lottie-web';
import React, { useEffect, useRef } from 'react';

import { ROUTE_AUTO_LOGIN, ROUTE_SCANBAT } from '@/common/constants';
import loader from '@/ebat/assets/loader/loader.json';
import scanbatLoader from '@/ebat/assets/loader/loader-scanbat.json';

import {
  PageLoaderDefaultProps,
  PageLoaderPropTypes,
} from './PageLoader.proptypes';

const PageLoader = ({ className, redirectUri }) => {
  const loaderRef = useRef(null);
  const isScanbat =
    window.location.pathname.includes(ROUTE_SCANBAT) ||
    (window.location.pathname.includes(ROUTE_AUTO_LOGIN) &&
      redirectUri?.includes(ROUTE_SCANBAT));

  useEffect(() => {
    if (loaderRef.current) {
      lottie.loadAnimation({
        container: loaderRef.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: isScanbat ? scanbatLoader : loader,
      });
    }
  }, [isScanbat]);

  return (
    <main className={cn('main', className)}>
      <div className="page-loader">
        <div ref={loaderRef} className="page-loader__item" />
      </div>
    </main>
  );
};

PageLoader.defaultProps = {
  ...PageLoaderDefaultProps,
};

PageLoader.propTypes = {
  ...PageLoaderPropTypes,
};

export default PageLoader;
